import { render, staticRenderFns } from "./Dropfile.vue?vue&type=template&id=6fa2820d&scoped=true&"
import script from "./Dropfile.vue?vue&type=script&lang=js&"
export * from "./Dropfile.vue?vue&type=script&lang=js&"
import style0 from "./Dropfile.vue?vue&type=style&index=0&id=6fa2820d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa2820d",
  null
  
)

export default component.exports